import { render } from "./LoginComponent.vue?vue&type=template&id=bee367be&ts=true"
import script from "./LoginComponent.ts?vue&type=script&lang=ts"
export * from "./LoginComponent.ts?vue&type=script&lang=ts"

import "./LoginComponent.vue?vue&type=style&index=0&id=bee367be&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__